export default "__VITE_ASSET__DusF$Iiq__"